<template>
  <canvas
    :id="chartData.id"
  />
</template>
<script>
import Chart from 'chart.js/auto'
export default {
  name: 'BaseBarHorizontalChartCommercialisation',
  props: {
    chartData: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      chart: null,
      options: {
        aspectRatio: 8,
        responsive: true,
        indexAxis: 'y',
        layout: {
          padding: {
            left: -10
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: 'nearest',
            caretSize: 0,
            xAlign: 'right',
            yAlign: 'center',
            callbacks: {
              title: () => {
                return ''
              },
              label: (context) => {
                return context.dataset.label
              }
            }
          },
          datalabels: {
            anchor: 'end',
            align: 'start',
            formatter: ((value, index) => {
              return index.datasetIndex === 0 ? `${value}%` : null
            }),
            color: '#F1F2F5',
            font: {
              weight: '500'
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            ticks: {
              display:false,
            },
            grid: {
              display: false,
              drawBorder: false
            }
          },
          y: {
            stacked: true,
            ticks: {
              display:false,
            },
            grid: {
              display: false,
              drawTicks: false,
              drawBorder: false
            }
          }
        }
      }
    }
},

  watch: {
    chartData: {
      handler () {
        this.chart.data = this.chartData
        this.chart.update()
      }
    }
  },
  mounted () {
    const config = {
      options: this.options,
      data: this.chartData
    }
    this.chart = new Chart(document.getElementById(this.chartData.id), config)
  }
}
</script>